import { ReportDiffState } from '../models/ReportDiffState';

export class ReportDiffStateMapper {
  mapState(state: string): ReportDiffState {
    switch (state) {
      case 'DONE':
        return ReportDiffState.DONE;
      case 'PENDING':
      case 'PROGRESS':
        return ReportDiffState.PENDING;
      case 'FAILED':
      default:
        return ReportDiffState.FAILED;
    }
  }
}
